/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffAccountLinkLineEndpointRequest
 */
export interface PostLiffAccountLinkLineEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffAccountLinkLineEndpointRequest
     */
    oneTimePassword: string;
}

/**
 * Check if a given object implements the PostLiffAccountLinkLineEndpointRequest interface.
 */
export function instanceOfPostLiffAccountLinkLineEndpointRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oneTimePassword" in value;

    return isInstance;
}

export function PostLiffAccountLinkLineEndpointRequestFromJSON(json: any): PostLiffAccountLinkLineEndpointRequest {
    return PostLiffAccountLinkLineEndpointRequestFromJSONTyped(json, false);
}

export function PostLiffAccountLinkLineEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffAccountLinkLineEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oneTimePassword': json['oneTimePassword'],
    };
}

export function PostLiffAccountLinkLineEndpointRequestToJSON(value?: PostLiffAccountLinkLineEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oneTimePassword': value.oneTimePassword,
    };
}

